export default __webpack_public_path__ + "static/sales-alerts-9f525449f9ca241d8c72f16da936af82.svg";